export default __webpack_public_path__ + "static/media/Background_00194.92f1e76f.png";